<template>
  <div class="mse-sign">
    <div id="big-sign">
      <div id="main-sign">
        <!-- 知识竞赛标题（移至表格上方并优化样式） -->
        <div class="competition-title">
          自治区交通运输行业 2026 年“丝路交通杯·安康杯”安全宣讲暨安全生产知识竞赛
        </div>

        <div style="margin-top: 20px;background: #fff;">
          <p class="account-sign">已有账号，去<span class="account-sp" @click="toRouter"> 登录</span></p>
          <van-collapse>
            <van-collapse-item name="1">
              <div class="table-main-sign1-sign">
                <p>
                  <a>姓名</a>
                  <input class="inputs-t" type="text" v-model="stuname"/>
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>身份证号</a>
                  <input class="inputs-t" type="text" v-model="cardid"/>
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>手机号码</a>
                  <input class="inputs-t" type="text" v-model="phone"/>
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>企业名称</a>
                  <input class="inputs-t" type="text" v-model="enterpriseName"/>
                </p>
              </div>

              <div class="table-main-sign1-sign">
                <p>
                  <a>行业类别</a>
                  <select class="select-sgin" v-model="jobtype">
                    <option>-请选择-</option>
                    <option value="1015">道路旅客运输</option>
                    <option value="1017">道路危货运输</option>
                    <option value="1016">道路普货运输</option>
                  </select>
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>身份</a>
                  <select class="select-sgin" v-model="identityType">
                    <option selected>-请选择-</option>
                    <option value="10001001">企业主要负责人</option>
                    <option value="10001002">安全生产管理人员</option>
                    <option value="10006003">其它</option>
                  </select>
                </p>
              </div>

              <div>
                <p style="color: #969799; display: flex; align-items: center;">
                  <a style="width: 1.8rem; text-align: center; background: #FBFBFB;">默认登录密码</a>
                  <span style="color: #969799;">123456</span>
                  <span style="font-size: 0.22rem">（系统自动生成，登录后可修改）</span>
                </p>
              </div>

            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
    <div class="button-ce-s"><button class="button-sign" @click="submitSign">签到</button></div>
  </div>
</template>
<script>
import request from '@/utils/request';
import {Dialog, Notify} from "vant";
export default {
  components: {
    [Notify.name]: Notify
  },
  data() {
    return {
      type:'',

      stuname:'',//学员名称
      stupwd:'123456',//密码
      intStupwd:'',//密码
      stusex:'',//学员性别
      pxnf:'',//培训年度
      cardid:'',//身份证
      phone:'',//手机号
      jobtype:'',//行业类别
      identityType:'',
      enterpriseName:''
    };
  },
  created() {
  },
  // this.$route.query.subsystemId;
  // this.$route.query.costMode;

  methods: {

    toRouter() {
      // 主动触发点击事件
      this.$router.push({
        name: "SignInCjHtml",
        query: {},
      });
    },

    //提交
    submitSign(){
      //校验字段
      if (this.stuname==''){
        Notify("请填写姓名");
        return;
      }
      if (this.cardid==''){
        Notify("请选填写身份证");
        return;
      }else {
        if(!(/^\d{15}|\d{18}$/.test(this.cardid))){
          Notify("身份证格式错误");
          return;
        }
      }
      if (this.phone==''){
        Notify("请填写手机号");
        return;
      }else {
        if(!(/^1[3456789]\d{9}$/.test(this.phone))){
          Notify("手机号格式错误");
          return;
        }
      }

      if (this.enterpriseName==''){
        Notify("请填写企业名称");
        return;
      }

      if (this.jobtype==''){
        Notify("请选择行业类别");
        return;
      }

      if(this.identityType == '') {
        Notify("请选择学员身份");
        return;
      }

      //昌吉知识竞赛
      let urls = Global.env + Global.apiCore.saveCjStudent;
      request({
        url: urls,
        method: 'post',
        data:{
          stuname:this.stuname,//学员名称
          stupwd:this.stupwd,//密码
          stusex:this.stusex,//学员性别
          pxnf:this.pxnf,//培训年度
          cardid:this.cardid,//身份证
          phone:this.phone,//手机号
          jobtype:this.jobtype,//行业类别
          identityType:this.identityType,
          enterpriseName:this.enterpriseName
        },
      }).then(response => {
        if (response.resultCode == '1000') {
          //报名成功
          this.toRouter();
        }else {
          Notify(response.resultDesc);
          // setTimeout(() => {
          //   this.toRouter();
          // }, 10000);
        }
      })
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">


/* 知识竞赛标题样式优化 */
.competition-title {
  width: 92.5%;
  margin: 0 auto 0.3rem; /* 底部留出间距 */
  padding: 0.3rem 0;
  text-align: center;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333;
  border-bottom: 2px solid #1e9fff; /* 底部蓝色边框强调 */
  letter-spacing: 0.02rem; /* 字间距优化 */
}
.account-sp{
  color: red;
  font-size: 0.35rem
}
.account-sign{
  float: right;
  margin-right: 0.5rem
}
.button-ce-s{
  width: 100%;
  text-align: center
}
.button-sign{
  height: 0.78667rem;
  line-height: .78667rem;
  padding: 0 0.73333rem;
  font-size: .28333rem;
  background-color: #1e9fff;
  margin-bottom: 1rem;
  border: none;
  color: #ffff;
  font-weight: bold;
  margin-top: 0.3rem;
}
.img-but{
  margin-bottom: 0.5rem!important;
}
.img-sign{
  margin-left: 2.38rem;
  width: 4rem;
  margin-top: -0.8rem;
}
.select-sgin{
  width: 70%;
  border: none;
  font-size: .28rem;
  height: 100%;
  background-color: #ffff;
}
.mse-sign {
  #big-sign {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #f9f9f9;
  }

  #imgFanhui {
    display: block;
    width: 0.2rem;
    height: 0.36rem;
    position: absolute;
    left: 0.3rem;
    top: 0.26rem;
  }

  #header {
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background: #383952;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: #fff;
  }

  #main-sign {
    flex: 1;
    background: #ffffff;
    overflow-y: auto;
  }

  #nav {
    width: 100%;
    // height: 2rem;
    background: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  #nav p {
    /*float: left;*/
    display: inline-block;
    width: 1.46rem;
    height: 0.68rem;
    line-height: 0.68rem;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border: 1px solid rgba(50, 51, 51, 1);
    margin: 0.32rem 0 0.2rem 0.72rem;
  }

  .ys {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys1 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys2 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  #money {
    width: 100%;
    height: auto;
    background: #fff;
    margin-bottom: 0.2rem;
  }

  #money p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
    margin: 0 auto;
  }

  #money p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  #money p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  #money p span a {
    color: rgba(51, 51, 51, 1);
  }

  #need {
    color: rgba(255, 180, 0, 1) !important;
  }

  #btn {
    width: 92.5%;
    height: 0.82rem;
    line-height: 0.82rem;
    background: #f63c45;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 0.88rem;
    text-align: center;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    font-size: 0.34rem;
    margin-bottom: 0.2rem;
    cursor: pointer;
    overflow: hidden;
  }
  #showTime {
    font-size: 0.32rem;
    line-height: 0.72rem;
    padding-left: 0.7rem;
  }

  .table-main-sign {
    width: 100%;
    height: auto;
    background: #fff;
  }
  .table-main-sign1-sign {
    width: 100%;
    height: auto;
    background: #fff;
    overflow: hidden;
    margin-bottom: 0.3rem;
  }
  .table-main-sign p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
    margin: 0 auto;
    overflow: hidden;
  }

  .table-main-sign p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  .table-main-sign p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  .table-main-sign p span a {
    color: rgba(51, 51, 51, 1);
  }
  .fp {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fp:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fp11 {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }

  .fpss {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-left: 0.3rem;
    border-radius: 4px;
  }
  .fpss1 {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-right: 0.3rem;
    border-radius: 4px;
  }
  .fpss:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpss1:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpxx {
    display: block;
    width: 2.5rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fpxx:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fps {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .table-kfp {
    height: 0.88rem;
    width: 100%;
    background: #f3f3f4;
  }
  .table-kfp p {
    width: 92.5%;
    height: 0.88rem;
    line-height: 0.88rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #666666;
  }
  .table-main-sign1-sign p {
    width: 99.5%;
    height: 0.8rem;
    line-height: 0.8rem;
    border: 0.02rem solid #e6e6e6;
    margin: 0 auto;
  }

  .table-main-sign1-sign p a {
    float: left;
    font-size: .28rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
    width: 1.8rem;
    text-align: center;
    /* height: 0.5rem; */
    height: 100%;
    border-right: .02rem solid #e6e6e6;
    background-color: #FBFBFB;
  }
  .table-main-sign1-sign p span {
    float: left;
    font-size: 0.32rem;
    font-weight: 400;
    margin-left: 0.5rem;
  }

  .table-main-sign1-sign p span a {
    color: rgba(51, 51, 51, 1);
  }
  .inputs-t {
    float: none;
    width: 5.2rem;
    height:99%;
    line-height: 99%;
    color: #666;
    text-align: left;
    font-size: .28rem;
    border: none;
    margin-left: .06rem;
  }
  .van-cell {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin: 0 auto;
    box-sizing: border-box;
    width: 92.5%;
    /* padding: .13333rem .21333rem; */
    overflow: hidden;
    color: #323233;
    font-size: 0.32rem !important;
    line-height: 0.32rem;
    background-color: #fff;
    padding: 0.3rem 0;
    border: none !important;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
  }
  #gs {
    position: absolute;
    font-size: 0.32rem;
    z-index: 99999;
    right: 0.8rem;
    top: 0.26rem;
  }
  .van-collapse-item__content {
    padding: 0 !important;
    color: #969799;
    font-size: 0.32rem !important;
    line-height: 1.5;
    background-color: #fff;
  }
  input {
    background: #fff;
    border: none;
  }
  input[type='radio'] + label::before {
    content: '\a0'; /*不换行空格*/
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    border-radius: 50%;
    border: 1px solid #01cd78;
    text-indent: 0.15em;
    line-height: 1;
  }
}
</style>
